import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AskServerService } from '../ask-server.service';

import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-accueil',
  templateUrl: './accueil.component.html',
  styleUrls: ['./accueil.component.scss']
})
export class AccueilComponent implements OnInit {
  id: string;

  constructor(
    private askServer: AskServerService,
    private activatedRoute: ActivatedRoute,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    protected $gaService: GoogleAnalyticsService
  ) {
    iconRegistry.addSvgIcon(
      'wifi',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/wifi.svg')
    );
  }

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    if (this.id === null) {
      this.id = '';
    }
    this.$gaService.pageView('/', 'Accueil');
    //this.askServer.ouvertureTable(this.id);
  }
}
